import axios from "axios";
import { getUnexpiredToken } from "@/utils/utils";
import type { SignedInSessionResource } from "@clerk/types";
import { toast } from "sonner";
import { stripHexPrefix } from "@/components/RightStyle/TailwindStylingPanel/components/input/color-picker/utils/colorFormatUtils";
import type { DesignTokenApiResponse } from "../store/designTokensStore";
import type { ColorToSave } from "../hooks/useDesignTokens";

export async function fetchDesignTokens(
  canvasId: string,
  session: SignedInSessionResource,
): Promise<DesignTokenApiResponse> {
  const token = await getUnexpiredToken(session);
  const res = await axios.get(
    `${
      import.meta.env.VITE_BACKEND_BASE_URL
    }/canvases/${canvasId}/tailwind/colors`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return res.data;
}

export function formatColorsForApi(colors: ColorToSave[]) {
  return colors.map((color) => ({
    groupName: color.group || color.name,
    colorName: color.name,
    value: stripHexPrefix(color.value),
    isDark: color.isDark,
  }));
}

export function handleApiError(error: unknown, defaultMessage: string): string {
  const errorMessage =
    (error as { response?: { data?: { error?: string } } })?.response?.data
      ?.error || (error instanceof Error ? error.message : defaultMessage);

  toast.error(defaultMessage, {
    description: errorMessage,
    duration: 5000,
  });

  return errorMessage;
}
